import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { OrderCCTVModel } from 'sections/LKSection/modules/OrderModule/stores/models/OrderCCTVModel/OrderCCTVModel'

export class ValidateOrderCCTV extends ValidateFormService {
  validate = (model: OrderCCTVModel, returnType: 'boolean' | 'array' = 'boolean') => {
    const errors: string[] = []

    const getKey = (key: string) => `${OrderKeys.activateOrderPage}.validate.${key}`

    if (model.vendorValue === null) {
      errors.push(i18next.t(getKey('invalidVendorValue')))
    }
    if (model.url.trim().length === 0) {
      errors.push(i18next.t(getKey('invalidVideoServiceUrl')))
    }
    if (model.invalidUrl) {
      errors.push(i18next.t(getKey('invalidVideoServiceUrlFormat')))
    }
    if (model.login.trim().length === 0) {
      errors.push(i18next.t(getKey('invalidLogin')))
    }
    if (model.password.trim().length === 0) {
      errors.push(i18next.t(getKey('invalidPassword')))
    }
    if (model.hasToken && model.token.trim().length === 0) {
      errors.push(i18next.t(getKey('invalidToken')))
    }

    return returnType === 'boolean' ? this.hasNotErrors(errors, i18next.t(getKey('invalidValidateCCTVForm'))) : errors
  }
}

export const validateOrderCCTV = new ValidateOrderCCTV()
